import api from 'config/api';
import { cookieName } from 'config';
import Cookies from 'js-cookie';

const getToken = () => {
    const auth = Cookies.get(cookieName);

    return auth || null;
};

export default function (path) {
    const token = getToken();

    return `${api.url}${path}?_token=${token}`;
}
